// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9fc3a9d4","239":"6e1ba6de","453":"c76b3a71","455":"1ba2ba0b"}[chunkId] + ".chunk.js";
};